import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import AppTopBar from "../layout/subcomponents/header";
import BottomBar from "../layout/subcomponents/footer";
import SideMenu from "../layout/subcomponents/sideMenu";
import { LayoutProvider } from "../../middlewares/LayoutContext";
import { useSelector } from "react-redux";
import drawerDim from "../../theme/drawerDimensions";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  // Get sidebar collapse state from Redux
  const sidebarCollapsed = useSelector((state) => state.collapseValues.sidebarCollapsed);

  // Calculate main content width based on device and collapse state
  const getMainContentWidth = () => {
    if (isMobile) {
      return '100%'; // Mobile: full width (no sidebar initially)
    } else if (isTablet) {
      return `calc(100% - 80px)`; // Tablet: always collapsed
    } else if (isDesktop) {
      return `calc(100% - ${sidebarCollapsed ? drawerDim.collapsedWidth : drawerDim.width}px)`; // Desktop: dynamic
    }
    return '100%';
  };

  return (
    <LayoutProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppTopBar />
        <SideMenu />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: getMainContentWidth(),
            transition: 'width 0.3s ease-in-out',
          }}
        >
          <BottomBar />
        </Box>
      </Box>
    </LayoutProvider>
  );
}

export default Layout;